"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScopeListed = void 0;
/**
 * Determines whether the checked scope is listed in the actual scope.
 */
function isScopeListed(checkedScope, actualScope) {
    var checkedScopeList = checkedScope.trim().toLowerCase().split(/\s+/);
    var actualScopeList = actualScope.trim().toLowerCase().split(/\s+/);
    return checkedScopeList.every(function (scope) { return actualScopeList.indexOf(scope) !== -1; });
}
exports.isScopeListed = isScopeListed;
//# sourceMappingURL=isScopeListed.js.map